<template>
  <div>
  <v-toolbar class="primary" dark>
    <v-toolbar-title class="align-self-center" >{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
      <v-btn
        outline color="white"
        @click="newItem"
      >
        <v-icon left light>note_add</v-icon>New Item
      </v-btn>
  </v-toolbar>
  <v-container fluid grid-list-md>
    <v-data-iterator
      :items="items"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      content-tag="v-layout"
      hide-actions
      row
      wrap
    >
      <template slot="item" slot-scope="props">
        <v-flex
          xs12
          sm6
          md4
          lg3
        >
          <user-class-card
            :id="props.item"
            :section="section"
            @deleteNull="removeNull"
          ></user-class-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </v-container>
  </div>
</template>

<script>
  import UserClassCard from './userClassCard'
  import {db} from '../../firebaseDB'

  export default {
    name: 'UserTables',
    components: {UserClassCard},
    data: () => ({
      rowsPerPageItems: [12, 24, 32],
      pagination: {
        rowsPerPage: -1
      },
      items: []
    }),
    created () {
      db.ref(`assets/asset_data/user/sections/${this.section}`)
        .on('value', (snapshot) => {
          this.items = (snapshot.val()) ? Object.keys(snapshot.val())
            .filter(k => snapshot.val()[k])  // filters out the deleted items
            : []
        }
        )
    },
    props: {
      title: String,
      section: String
    },
    methods: {
      newItem () {
        this.items.push(null)
      },
      removeNull () {
        const index = this.items.indexOf(null)
        if (index > -1) {
          this.items.splice(index, 1)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/userTables.vue